import type { Brand } from '@apiTypes';

const normalize = (str: string) =>
    str.normalize('NFD').replace(/\p{M}/gu, '').toLocaleLowerCase();

export const filterByStartLetter = (brand: Brand, startLetter: string) => {
    if (startLetter === '0-9') return /^\d/.test(brand.name);
    return normalize(brand.name).startsWith(normalize(startLetter));
};

const filterBrands = (brands: Brand[], query: string, startLetter?: string) => {
    return brands.filter(
        brand =>
            normalize(brand.name).includes(normalize(query)) &&
            (startLetter ? filterByStartLetter(brand, startLetter) : true)
    );
};

export default filterBrands;
